
import { Component, Vue, Prop} from 'vue-property-decorator';   
import { namespace } from "vuex-class";  

import Tooltip from "@/components/survey/Tooltip.vue";
import PageBase from "../PageBase.vue";

import { stepInfoType, stepResultInfoType } from "@/types/Application";

import "@/store/modules/application";
import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
const applicationState = namespace("Application");

import { togglePages } from '@/components/utils/TogglePages';

@Component({
    components:{
        PageBase,
        Tooltip
    }
})
export default class ReasonForScheduling extends Vue {
        
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;    

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    @applicationState.Action
    public UpdatePathwayCompleted!: (changedpathway) => void

    
    selectedReason = [];
    currentStep =0;
    currentPage =0;   

    mounted(){      
        this.reloadPageInformation();
    }

    public reloadPageInformation() {
        
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;    
        
        this.selectedReason = [];

        if (this.step.result?.reasonForSchedulingSurvey?.data){
            this.selectedReason = this.step.result.reasonForSchedulingSurvey.data;
            this.setPages();                          
        }        
       
        const progress = this.selectedReason.length==0? 50 : 100;        
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);     
    }

    public setPages() {

        const p = this.stPgNo.RQS;
        const requiresInterimOrderPage = this.selectedReason?.length >0?(this.selectedReason?.includes('orderChanged') || this.selectedReason?.includes('family')):false;
        
        togglePages([p.InterimOrder], requiresInterimOrderPage, this.currentStep);
       
    }  
    
    public onChange(selectedReason) {
        this.UpdatePathwayCompleted({pathway:"requestScheduling", isCompleted:false})
           
        this.setPages();   
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage();
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();       
    }   

    public getSelectedReasons(){
        let result = ''
        for(const reason of this.selectedReason){
            if(reason=='adjourned')               result+='It was adjourned by the court without setting a new date'+'\n';
            if(reason=='struck')                  result+='It was struck from the court list by the court'+'\n';
            if(reason=='party')                   result+='The court:<ul><li>referred a party to a program, professional or resource</li><li>required a party to attend, participate or complete a requirement</li></ul>'+'\n';
            if(reason=='deficiency')              result+='We fixed a deficiency under the rules'+'\n';
            if(reason=='orderChanged')            result+='There is an interim order that needs to be changed, suspended or cancelled'+'\n';
            if(reason=='family')                  result+='I already attended a family management conference and I need an interim order on my family law matter before my next court date'+'\n';
        }
        return result;
    }   

    beforeDestroy() {
        const progress = this.selectedReason.length==0? 50 : 100;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);
        const questions = [{name:'ReasonForScheduling',title:'I need to schedule a court appearance on my application because:',value:this.getSelectedReasons()}]        
        this.UpdateStepResultData({step:this.step, data: {reasonForSchedulingSurvey: {data: this.selectedReason, questions: questions, pageName:"Reason for Scheduling", currentStep:this.currentStep, currentPage:this.currentPage}}});
    }
}
